import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getDevelopmentPath } from "@core/schema/paths/getDevelopmentPath.js";
import { getWebAppsPath } from "@core/schema/paths/getWebAppsPath.js";

export function getServicesCloud(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "Cloudové konzultace",
			desc: `Nevíte si s cloudem rady, nebo máte nezodpovězené otázky? Rádi vám pomůžeme v rámci odborného poradenství na cloudových konzultacích. Zanalyzujeme vaši aktuální situaci a navrhneme řešení. Budete-li potřebovat, poskytneme vám i další IT konzultace.`,
		},
		{
			title: "Sestavení cloudové infrastruktury (IaC)",
			desc: "Cloudovou infrastrukturu vytváříme a spravujeme pomocí Infrastructure as Code (IaC), což umožňuje její rychlou automatizaci a nasazení. IaC zároveň zaručuje konzistenci napříč celou vaší IT infrastrukturou.",
		},
		{
			title: "Vývoj aplikací v cloudu",
			desc: `Specializujeme se na [${getDevelopmentPath(tenant)}][[vývoj]] škálovatelných a maximálně zabezpečených aplikací ([${getWebAppsPath(tenant)}][[webových]] i mobilních) přímo v cloudu, vyvíjíme primárně na cloudu AWS (Amazon Web Services). Od návrhu až po nasazení se zaměřujeme na vytváření výkonných a flexibilních aplikací, které zrychlí růst vašeho podnikání.`,
		},
		{
			title: "Migrace do cloudu",
			desc: "Pomůžeme vám s rychlým, bezpečným a pohodlným přesunem vašich dat a aplikací do cloudového prostředí. Postaráme se, aby během migrace nedošlo k výpadkům nebo ztrátě dat. Navrhneme strategii migrace, která minimalizuje rizika a zajistí bezproblémový přechod vašich systémů na cloud.",
		},
		{
			title: "Cloudová optimalizace",
			desc: "Provedeme audit vašeho cloudového prostředí a navrhneme konkrétní kroky, které zvýší výkon vašich systémů či aplikací a sníží provozní náklady. Zkrátka vám pomůžeme z cloudu vytěžit maximum.",
		},
		{
			title: "Technická podpora a správa cloudu",
			desc: "Nechcete mít s firemním cloudem starosti? Poskytneme vám technickou podporu a správu 24 hodin denně a 7 dní v týdnu. Sledujeme výkon, zajišťujeme bezpečnostní aktualizace a rychle řešíme případné problémy. Vy se tak můžete v klidu soustředit na své podnikání.",
		},
	];
}
